import { render } from "./addModuleVipPackage.vue?vue&type=template&id=7e9dd36f"
import script from "./addModuleVipPackage.vue?vue&type=script&lang=js"
export * from "./addModuleVipPackage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__